exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".simulation__CustomBarChartWithCircle{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/PortfolioDashboard/navigationPages/simulation/simulation.scss
// module id = 1465
// module chunks = 0